import type {RepoStackSummary} from '@github-ui/dotcom-schema/types/pull_requests/v1/repo_stacks'
import {ProgressBar} from '@primer/react'

import styles from './Stacks.module.css'

type StackProgressProps = Pick<RepoStackSummary, 'mergedCount' | 'unmergedCount'>

/** How much of a stack has merged. Closed, queued, open, and draft pull requests are all unmerged. */
export function StackProgress({mergedCount, unmergedCount}: StackProgressProps) {
  const total = mergedCount + unmergedCount
  const mergedPercentage = total > 0 ? Math.floor((mergedCount / total) * 100) : 0

  return (
    <div className={styles.progress}>
      <ProgressBar progress={mergedPercentage} barSize="small" aria-hidden="true" className={styles.progressBar} />
      <div className={styles.progressCounts}>
        <span>
          <span className={styles.progressCount}>{mergedCount}</span> merged
        </span>
        <span>
          <span className={styles.progressCount}>{unmergedCount}</span> unmerged
        </span>
      </div>
    </div>
  )
}
